import { Component, OnInit } from '@angular/core';
import { AuthenticationService, ProfileService, AlertService} from '../_services/index';
import {Router, ActivatedRoute} from "@angular/router"
import { AsapScheduler } from 'rxjs/internal/scheduler/AsapScheduler';
// import { stringify } from 'querystring';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  private authorized:any;
  public param:any;
  public users:any;
  public roles:any;
  public a:any;
  constructor(
    public profileService: ProfileService,
    private router: Router,
    public as: AuthenticationService,
    private route: ActivatedRoute,
  ) { 
    this.authorized = this.as.checkAuthentication();
      if(!this.authorized.authorized){
          this.router.navigate(['/login'])
      }
  }

  ngOnInit() {
    this.profileService.getRole().subscribe(response => {
      this.roles = response;  
    }, error => {
    })
    this.route.queryParams.subscribe(params => {
      this.a=JSON.stringify(params);
    });
    this.param = {
      page:JSON.parse(this.a).page?JSON.parse(this.a).page:1,
      offset:JSON.parse(this.a).offset?JSON.parse(this.a).offset:100,
      orderby:"[['lastName','"+(JSON.parse(this.a).lastName?JSON.parse(this.a).lastName:'ASC').toString()+"'],['companyId','"+(JSON.parse(this.a).companyId?JSON.parse(this.a).companyId:'ASC').toString()+"']]",
      lastName:JSON.parse(this.a).lastName?JSON.parse(this.a).lastName:'ASC',
      companyId:JSON.parse(this.a).companyId?JSON.parse(this.a).companyId:'ASC'
    }
    this.getUsers(this.param);
  }
  changeFilter(){
    console.log(this.param)
    this.param.orderby = "[['lastName','"+this.param.lastName.toString()+"'],['companyId','"+this.param.companyId.toString()+"']]",
    this.getUsers(this.param);
  }
  url(path: any){
    this.router.navigate([path]);
  }
  getUsers(data: any){
    this.profileService.getUsers(data).subscribe(response => {
        this.users = response;  
        if(!response){
          console.log(response)
        }
    }, error => {
        console.log(error)
    })
  }
}
